import React, { useState, useEffect } from 'react';
import './EpochsMinimap.scss';
import { TimelineEvent } from '../../types/epochs';
import { useEpochHeights } from '../../hooks/useEpochHeights';
import { useEpochsMinimap } from '../../hooks/useEpochsMinimap';
import { Timeline } from './Timeline';
import { EpochsContainer } from './EpochsContainer';
import { useScrollClose } from '../../hooks/useScrollClose';

interface EpochsMinimapProps {
  epochs: Epoch[];
  isVisible?: boolean;
  onClose?: () => void;
}

interface Epoch {
  title: string;
  period: string;
  color: string;
  events: TimelineEvent[];
}

const EpochsMinimap: React.FC<EpochsMinimapProps> = ({ 
  epochs,
  isVisible = false,
  onClose
}) => {
  const { isHovered, setIsHovered, hoveredEpoch, setHoveredEpoch } = useEpochsMinimap();
  const { epochRefs, epochHeights } = useEpochHeights(epochs);
  const [mounted, setMounted] = useState(false);
  
  useScrollClose(isVisible, isHovered, onClose);

  useEffect(() => {
    // Даем время для первоначального рендера
    requestAnimationFrame(() => {
      setMounted(true);
    });
  }, []);

  const shouldBeHidden = (!mounted && isVisible) || (mounted && !isVisible);

  return (
    <div 
      className={`epochMinimap ${shouldBeHidden ? 'hidden' : ''}`}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <Timeline 
        epochs={epochs}
        hoveredEpoch={hoveredEpoch}
      />
      <EpochsContainer 
        epochs={epochs}
        epochRefs={epochRefs}
        epochHeights={epochHeights}
        setHoveredEpoch={setHoveredEpoch}
        onClose={onClose}
      />
    </div>
  );
};

export default EpochsMinimap;